import Participants from '../ui/Participants';
import { useParticipants } from '../discord/useParticipants';

/**
 * Ce que voient ceux qui ne choisissent pas.
 *
 * Auparavant ils tombaient sur le catalogue et pouvaient lancer un film à la
 * place de celui qui avait ouvert la séance — le serveur l'acceptait, faute
 * de maître déclaré. La main se prend désormais à l'entrée, et cet écran est
 * la contrepartie visible : on sait qui choisit, et on n'a rien à faire.
 */
export default function Attente({ nomDuMaitre, maitreAbsent, onPrendreLaMain }) {
  const participants = useParticipants();

  return (
    <div className="centre">
      <div className="emoji">🍿</div>
      <h1 className="titre">{nomDuMaitre ? `${nomDuMaitre} choisit le film` : 'Séance en préparation'}</h1>
      <p className="discret">La lecture démarrera pour tout le monde en même temps.</p>

      <Participants participants={participants} />

      {maitreAbsent && (
        <>
          <p className="discret petit">Personne ne semble aux commandes.</p>
          <button type="button" onClick={onPrendreLaMain}>Choisir moi-même</button>
        </>
      )}
    </div>
  );
}
